import { useEffect, useRef, useState } from "react";

export function useScrollAnimation(threshold = 0.15, startVisible = false) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(startVisible);

  useEffect(() => {
    if (startVisible) return;
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, startVisible]);

  return [ref, isVisible];
}
